import EnterCodeModalWraper from './EnterVehicleCodeModalWrapper'
import enterCodeModalWrapperContainer from './enterVehicleCodeModalWrapperContainer'

export default enterCodeModalWrapperContainer(EnterCodeModalWraper)
